<template>
  <div class="history-custom-card h-100">
    <div class="history-header d-flex align-items-center">
      <font-awesome-icon :icon="['far', 'history']" fixed-width />
      <h6 class="m-0 ml-2 font-weight-bold text-dark">Historial Reciente</h6>
    </div>

    <div class="history-body">
      <div v-if="loading" class="d-flex justify-content-center py-4">
        <b-spinner type="grow" small class="text-primary"></b-spinner>
      </div>

      <template v-else>
        <div v-if="visits.length > 0">
          <a v-for="visit in visits" :key="visit.id" :href="visit.url" class="visit-link">
            <div class="row visit-row">
              <p class="col-3 col-label mb-0">{{ visit.label }}</p>
              <p class="col-3 col-text mb-0" :title="visit.code">{{ visit.code }}</p>
              <p class=" col-text mb-0" :title="visit.name">{{ visit.name }}</p>
            </div>
          </a>
        </div>

        <div v-else class="row justify-content-center mt-4 mb-4 pt-2 mx-0">
          <p class="pt-2 fs-12 text-muted"><i>No hay historial todavía</i></p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecentVisitsCard',
  props: {
    forDistributor: Boolean,
    forInstaller: Boolean
  },
  data() {
    return {
      loading: true,
      visitData: []
    }
  },
  computed: {
    visits() {
      return this.visitData.map(v => ({
        ...v,
        url: `/${this.urlFor(v.model_type)}/${v.model_id}`,
        label: this.labelFor(v.model_type)
      }))
    }
  },
  mounted() {
    this.fetchVisitData()
  },
  methods: {
    fetchVisitData() {
      this.$http.get('/api/visits')
        .then(response => {
          this.visitData = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    urlFor(type) {
      switch (type) {
        case 'Client':
          return 'app/prod/clientes'
        case 'Project':
          return 'app/prod/proyectos'
        case 'Quote':
          if (this.forDistributor) return 'app/dist/cotizador'
          if (this.forInstaller) return 'app/inst/cotizador'
          return 'app/prod/cotizador'
        case 'DistributorClient':
          return 'app/dist/clientes'
        case 'OC':
        case 'SOC':
          return 'app/prod/solicitud'
        case 'Puerta':
        case 'Control de Acceso':
        case 'Anden':
          return 'app/prod/submitals'
        case 'Seccional':
          return 'seccionales'
        default:
          return type.toLowerCase() + 's'
      }
    },
    labelFor(type) {
      switch (type) {
        case 'Client':
        case 'DistributorClient':
          return 'Cliente'
        case 'Project':
          return 'Proyecto'
        case 'Quote':
          return 'Cotización'
        case 'Template':
          return 'Plantilla'
        default:
          return type
      }
    }
  }
}
</script>

<style scoped lang="scss">
.history-custom-card {
  background-color: #ffffff;
  border: 1px solid #b8cde8;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  width: 100%;
  min-width: 0;
  contain: inline-size;
}

.history-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eaedf3;
  position: relative;
  // z-index: 20;
}

.history-body {
  background-color: #ffffff;
  padding: 4px 0;
  min-width: 0;
  overflow-x: hidden;
}

.visit-link {
  display: block;
  margin: 0 8px;
  border-radius: 8px;
  background-color: transparent;

  &,
  &:hover,
  &:focus,
  &:active {
    text-decoration: none !important;
    border: 0 !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &::before,
  &::after {
    display: none !important;
  }

  &:last-child .visit-row {
    border-bottom: 0 !important;
  }

  &:hover .visit-row {
    .col-label,
    .col-text {
      color: #163d7d;
    }
  }
}

.visit-row {
  margin: 0;
  padding: 12px;
  align-items: center;
  flex-wrap: nowrap;

  &,
  &:hover {
    border-top: 0 !important;
    border-bottom: 1px solid #eaedf3 !important;
    box-shadow: none !important;
  }

  &::before,
  &::after {
    display: none !important;
  }

  > [class*='col-'] {
    min-width: 0;
  }
}

.col-label,
.col-text {
  color: #6b7280;
  font-size: 13px;
  transition: color 0.15s ease;
}

.col-label {
  font-weight: 600;
}

.col-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
